import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'
import type { components } from '../../../constants/schema'

import { requestIdentityVerification } from '../../../utils/identityVerification'
import { handleIdentify } from '../../../utils/handleIdentify'

import { ModalContext } from '../../../provider/ModalProvider'

import { useIsMobile } from '../../../hooks/useIsMobile'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function VerificationNoticeModal() {
  const { closeModal } = useContext(ModalContext)

  const isMobile = useIsMobile()

  const requestVerification = async () => {
    closeModal(MODALS_ID.VERIFICATION_NOTICE)

    const response = await requestIdentityVerification(window.location.href)
    console.log({ response, isMobile, location })

    // mobile은 redirection이라 해당 코드가 실행 될 필요가 없음.
    // pc일때만 requestIdentityVerification 후에 코드 실행
    if (!isMobile && response && response.code !== 'FAILURE_TYPE_PG') {
      handleIdentify(response as components['schemas']['ReqQueryIdentification'])
      return
    }
  }

  return (
    <Modal id={MODALS_ID.VERIFICATION_NOTICE}>
      <Text size={18} weight={600} block={true} $textAlign="center">
        본인 인증 후 청약이 가능해요.
      </Text>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={requestVerification}>
          본인 인증하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
